import React, {useState, Fragment, useEffect} from 'react'
import {useDispatch, useSelector} from "react-redux"
import WebViewer from '@pdftron/webviewer'
import DateFnsUtils from "@date-io/date-fns"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

// Material-UI Element
import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Component
import FileDropzone from '../FileDropzone/FileDropzone'
import FileZoneContent from './FileZoneContent'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import {Alert} from '../Alert/Alert'

// Custom Style
import {docSubDetailFormStyle} from '../../styles/jss/components/documentSubmission/docSubDetailFormStyle'

// Global Function
import {getAdministrableRight, getModifyRight} from '../../global/userRight'

// Fetch Data
import {fileUpload} from '../../dataSource/fileManager'
import {getDocumentSubmissionDetail, documentSubmissionModifySave, documentSubmissionApproval} from '../../dataSource/documentSubmission'


const useStyles = makeStyles(theme => docSubDetailFormStyle(theme))

const DocSubDetailForm = props => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const {submissionSearchAction} = props

	// Redux Data
	const selectedSubmissionSeqRedux = useSelector(state => state.selectedSubmissionSeqRedux)
	const submissionDetailRedux = useSelector(state => state.submissionDetailRedux)
	const modifySubmissionValueRedux = useSelector(state => state.modifySubmissionValueRedux)
	const userModulesRedux = useSelector(state => state.userModulesRedux)
		
	const [submissionDetailResult, setSubmissionDetailResult] = useState(null)
	const [submissionValue, setSubmissionValue] = useState(null)
	const [modifyRefresh, setModifyRefresh] = useState(0)
	const [administrableRight, setAdministrableRight] = useState(false)
	const [modifyRight, setModifyRight] = useState(false)
	const [validationErrors, setValidationErrors] = useState({})

	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// const onDropCover = useCallback(acceptedFiles => {
	// 	fileUploadAction("file_cover", acceptedFiles)
	// })

	// const onDropPdf = useCallback(acceptedFiles => {
	// 	fileUploadAction("file_pdf", acceptedFiles)
	// })


	const fileUploadAction = (fileType, acceptedFilesPool) => {
		acceptedFilesPool.map(file => {
			fileUpload(file).then(res => {
				console.log("*****************************************************************************")
				console.log("Temporary upload File Successful")
				console.log(res)
				console.log("*****************************************************************************")

				buildFileRecord(fileType, res.data[0])
			})
		})
	}

	const buildFileRecord = (fileType, fileUploadRecord) => {
		const val = {...submissionValue.files}
		fileUploadRecord.modifydate = ""

		val[fileType].push(fileUploadRecord)

		setSubmissionValue({...submissionValue, files: val})
		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: {...submissionValue, files: val}
		})

		validate({...submissionValue, files: val})
	}


	// Handle Form Input
	const handleChange = event => {
		const {name, value} = event.target
		const res = {...submissionValue.values}

		res[name] = value
		setSubmissionValue({...submissionValue, values: res})
		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: {...submissionValue, values: res}
		})

		validate({...submissionValue, values: res})
	}


	const handleCheckboxChange = elementName => event => {
		const {name, checked} = event.target
		const res = {...submissionValue.values}

		if (res[elementName]) {
			var tempArray = res[elementName].split(",")
		}
		else {
			var tempArray = []
		}

		if (checked) {
			tempArray.push(name)
			res[elementName] = tempArray.toString()
			
			setSubmissionValue({...submissionValue, values: res})
			dispatch({
				type: "MODIFY_SUBMISSION_VALUE",
				data: {...submissionValue, values: res}
			})

		}
		else {
			if (tempArray.indexOf(name) > -1) {
				tempArray.splice(tempArray.indexOf(name), 1)
				res[elementName] = tempArray.toString()

				setSubmissionValue({...submissionValue, values: res})
				dispatch({
					type: "MODIFY_SUBMISSION_VALUE",
					data: {...submissionValue, values: res}
				})
			}
		}

		validate({...submissionValue, values: res})
	}


	const handleDateFieldChange = (date, name) => {
		const res = {...submissionValue.values}

		res[name] = date
		setSubmissionValue({...submissionValue, values: res})
		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: {...submissionValue, values: res}
		})

		validate({...submissionValue, values: res})
	}

	const handleReasonChange = event => {
		const {value} = event.target
		
		setSubmissionValue({...submissionValue, approval_reason: value})
		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: {...submissionValue, approval_reason: value}
		})
	}

	const handleApproval = stageSeq => {
		const approvalParams = {...submissionValue, stage_seq: stageSeq}

		setSubmissionValue(approvalParams)
		dispatch({
			type: "MODIFY_SUBMISSION_VALUE",
			data: approvalParams
		})

		approvalAction(approvalParams)
	}


	// Build Alert
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}


	// Build Confirm Dialog
	const confirmDialogHandleOpen = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})

		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Confirm Dialog action 
	const saveModifyConfirmAction = (submissionSeq) => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Document Submission Save Change",
				dialogContent: "Are you sure to save all modify.",
				confirmAction: () => saveModifyAction(submissionSeq),
				cancelAction: saveModifyCancelAction
			})
		}
	}

	const saveModifyCancelAction = () => {
		confirmDialogHandleClose()
	}


	const approvalConfirmAction = (stageSeq, stageName) => {
		confirmDialogHandleOpen({
			dialogTitle: "Document Submission Approval",
			dialogContent: `Are you sure to ${stageName} this document.`,
			confirmAction: () => handleApproval(stageSeq),
			cancelAction: approvalCancelAction
		})
	}

	const approvalCancelAction = () => {
		confirmDialogHandleClose()
	}



	// Main Action
	const saveModifyAction = (submissionSeq) => {
		confirmDialogHandleClose()

		documentSubmissionModifySave(submissionSeq, modifySubmissionValueRedux).then(res => {
			setModifyRefresh(modifyRefresh + 1)
			submissionSearchAction()

			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The modify of Document Submission have been save"
			})

			console.log("*****************************************************************************")
			console.log("System Module: Document Submission")
			console.log("Message: Save modify successful.")
			console.log(res)
			console.log("*****************************************************************************")
		})
	}

	const approvalAction = submissionApprovalParams => {
		documentSubmissionApproval(selectedSubmissionSeqRedux, submissionApprovalParams).then(res => {
			setModifyRefresh(modifyRefresh + 1)
			submissionSearchAction()
			approvalCancelAction()

			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The document stage have been change successful"
			})

			console.log("*****************************************************************************")
			console.log("System Module: Document Submission")
			console.log("Message: Approval successful.")
			console.log(res)
			console.log("*****************************************************************************")

		})
	}


	// Input Validation
	const validate = (fieldValues = submissionValue) => {
		let temp = {...validationErrors}

		submissionDetailResult.form.snapshot.map(res => {
			if (res.mandatory) {
				if (res.type !== "files_upload") {
					if (res.name in fieldValues.values) {
						temp[res.name] = fieldValues.values[res.name] ? "" : "This field is required"
					}
				}
				else {
					if (res.name in fieldValues.files) {
						temp[res.name] = fieldValues.files[res.name].length > 0 ? "" : "This field is required"
					}
				}
			}
		})

		setValidationErrors({...temp})

		if (fieldValues == submissionValue) {
			return Object.values(temp).every(x => x == "")
		}
	}


	useEffect(() => {
		getAdministrableRight(userModulesRedux, "/submission").then(res => {
			setAdministrableRight(res)
		})

		getModifyRight(userModulesRedux, "/submission").then(res => {
			setModifyRight(res)
		})
	})


	useEffect(() => {
		if(document.getElementById('webviewer')) {
			document.getElementById('webviewer').innerHTML = ''
		}

		console.log("*****************************************************************************")
		console.log("Webviewer Area")
		console.log(document.getElementById('webviewer'))
		console.log("*****************************************************************************")

		WebViewer({
			path: process.env.REACT_APP_PDFTRON_PATH,
			licenseKey: process.env.REACT_APP_PDFTRON_LICENSE_KEY
			// config: 'config.js' // path/to/your/config.js
		}, document.getElementById('webviewer')).then(instance => {

			// instance.docViewer.loadDocument(
			// 	`http://172.16.145.30:3003/api/v1/dms/property/download?seqs=${propertySeqRedux}&only_primary=true`, {
			// 	customHeaders: {
			// 		"Authorization": "Bearer " + store.get('access_token'),
			// 		"site": store.get('site'),
			// 		"locale": store.get('locale')
			// 	}
			// })
		})
	}, [])

	useEffect(() => {
		getDocumentSubmissionDetail(selectedSubmissionSeqRedux).then(res => {
			const subVal = {
				values: {},
				files: {}
			}

			res.data[0].form.snapshot.map(record => {
				if (record.type === "files_upload") {
					subVal.files[record.name] = res.data[0].files[record.name]
				}
				else if (record.type === "checkbox") {
					subVal.values[record.name] = res.data[0].values[record.name]
				}
				else {
					subVal.values[record.name] = record.value
				}
			})

			setSubmissionDetailResult(res.data[0])
			dispatch({
				type: "ADD_SUBMISSION_VALUE",
				data: res.data[0]
			})

			setSubmissionValue(subVal)
			dispatch({
				type: "MODIFY_SUBMISSION_VALUE",
				data: subVal
			})
		})
	}, [modifyRefresh])


	return (
		// console.log("Document Submission Detail Data | Variable: submissionDetailResult (DocSubDetailForm.js)"),
		// console.log(submissionDetailResult),

		// console.log("Document Submission Detail Data (Redux) | Variable: submissionDetailRedux (DocSubDetailForm.js)"),
		// console.log(submissionDetailRedux),

		// console.log("Document Submission Value | Variable: submissionValue (DocSubDetailForm.js)"),
		// console.log(submissionValue),

		// console.log("Document Submission Value (Redux) | Variable: modifySubmissionValueRedux (DocSubDetailForm.js)"),
		// console.log(modifySubmissionValueRedux),

		// console.log("---------------------------------------------------------------------------------"),

		
		<Fragment>
			<ConfirmDialog
				open={confirmDialogOpen}
				dialogTitle={confirmDialogData.dialogTitle}
				dialogContent={confirmDialogData.dialogContent}
				confirmAction={confirmDialogData.confirmAction}
				cancelAction={confirmDialogData.cancelAction}
			/>

			<Alert
				open={alertOpen}
				alertType={alertData.type}
				alertTitle={alertData.title}
				alertContent={alertData.content}
				handleClose={() => setAlertOpen(false)}
			/>

			<Grid container spacing={1}>
				<Grid item xs={12} sm={12} md={5}>
					<div className={classes.detailInformation}>
					{
						submissionDetailResult !== null ?
							<div>
								<div className={classes.itemRoot}>
									<Grid container spacing={1}>
										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Submission Number: <div className={classes.itemText}>{submissionDetailResult.subm_code}</div>
											</Typography>
										</Grid>
										
										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Category: <div className={classes.itemText}>{submissionDetailResult.type.type_name}</div>
											</Typography>
										</Grid>

										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Submission Company: <div className={classes.itemText}>{submissionDetailResult.company.company_name}</div>
											</Typography>
										</Grid>

										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Stage: <div className={classes.itemText}>{submissionDetailResult.stage.stage_name}</div> On  <div className={classes.itemText}>{submissionDetailResult.stage.stage_date}</div>
											</Typography>
										</Grid>

										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Reason: <div className={classes.reasonText}>{submissionDetailResult.stage.stage_reason}</div>
											</Typography>
										</Grid>
									</Grid>
								</div>
								<Divider className={classes.divider} />
							</div>
						: ""
					}

					<div className={classes.textRoot}> 
						{
							submissionDetailResult !== null && submissionValue !== null ?
								submissionDetailResult.form.snapshot.map(element => {
									switch (element.type) {
										case "text":
											return (
												<TextField
													key={element.id}
													id={element.id}
													name={element.name}
													label={element.display_name}
													required={element.mandatory}
													type="text"
													fullWidth={true}
													size="small"
													variant="outlined"
													value={submissionValue.values[element.name] || ""}
													onChange={handleChange}
													error={validationErrors[element.name] && validationErrors[element.name] !== "" ? true : false}
													helperText={validationErrors[element.name]}
													InputProps={{
														readOnly: !submissionDetailResult.options.updatable
													}}
												/>
											)
										
										case "select":
											return (
												<TextField
													select
													required
													fullWidth
													key={element.id}
													id={element.id}
													name={element.name}
													label={element.display_name}
													required={element.mandatory}
													size="small"
													variant="outlined"
													value={submissionValue.values[element.name] || ""}
													onChange={handleChange}
													error={validationErrors[element.name] && validationErrors[element.name] !== "" ? true : false}
													helperText={validationErrors[element.name]}
													InputProps={{
														readOnly: !submissionDetailResult.options.updatable
													}}
												>
													{
														element.childs.map(res => (
															<MenuItem key={res.value} value={res.value}>{res.display_name}</MenuItem>
														))
													}
												</TextField>
											)


										case "checkbox":
											return(
												<div key={element.id}>
													<Box 
														border={1}
														borderRadius="borderRadius" 
														borderColor={element.mandatory ? validationErrors[element.name] && validationErrors[element.name] ? "error.main" : "grey.400" : "grey.400"}
														className={classes.checkboxArea}
													>
														<Typography 
															variant="button"
															color={element.mandatory ? validationErrors[element.name] && validationErrors[element.name] ? "error" : "textPrimary" : "textPrimary"}
														>
															{element.mandatory ? element.display_name + " *" : element.display_name}
														</Typography>

														<FormGroup row={true}>
															{
																element.childs.map((cbox, index) => {
																	return (
																		<FormControlLabel
																			key={index}
																			control={
																				<Checkbox
																					checked={submissionValue.values[element.name].indexOf(cbox.name) > -1 ? true : false}
																					onChange={handleCheckboxChange(element.name)}
																					name={cbox.name}
																					color="primary"
																				/>
																			}
																			label={cbox.display_name}
																		/>
																	)
																})
															}
														</FormGroup>
													</Box>
													{
														element.mandatory ? 
															validationErrors[element.name] && validationErrors[element.name] ?	
																<Typography variant="caption" color="error" className={classes.requireErrorMsg}>{validationErrors[element.name]}</Typography> 
															: "" 
														: ""
													}
												</div>
											)

										case "textarea":
											return (
												<TextField
													fullWidth
													multiline
													rows={4}
													key={element.id}
													id={element.id}
													name={element.name}
													label={element.display_name}
													required={element.mandatory}
													size="small"
													variant="outlined"
													value={submissionValue.values[element.name] || ""}
													onChange={handleChange}
													error={validationErrors[element.name] && validationErrors[element.name] !== "" ? true : false}
													helperText={validationErrors[element.name]}
													InputProps={{
														readOnly: !submissionDetailResult.options.updatable
													}}
												/>
											)

										case "datepicker": 
											return (
												<MuiPickersUtilsProvider utils={DateFnsUtils} key={element.id}>
													<KeyboardDatePicker
														id={element.id}
														name={element.name}
														label={element.display_name}
														required={element.mandatory}
														format="dd/MM/yyyy"
														placeholder="DD/MM/YYYY"
														size="small"
														inputVariant="outlined"
														KeyboardButtonProps={{
															"aria-label": "change date"
														}}
														className={classes.datePickerField}
														value={submissionValue.values[element.name] !== "" ? submissionValue.values[element.name] : null}
														onChange={date => handleDateFieldChange(date, element.name)}
														error={validationErrors[element.name] && validationErrors[element.name] !== "" ? true : false}
														helperText={validationErrors[element.name]}
														InputProps={{
															readOnly: !submissionDetailResult.options.updatable
														}}
														readOnly={!submissionDetailResult.options.updatable}
													/>
												</MuiPickersUtilsProvider>
											)
										
										case "files_upload":
											return (
												<FileDropzone
													key={element.id}
													title={element.display_name + " *"}
													fileType={element.name}
													disabled={false}
													fileUploadAction={fileUploadAction}
													DropzoneContent={FileZoneContent}
													required={true}
													error={validationErrors[element.name] && validationErrors[element.name] !== "" ? true : false}
													helperText={validationErrors[element.name]}
												/>
											)
									}
								})

							: ""
						}

						{
							submissionDetailResult !== null ?
								administrableRight ?
									<TextField
										fullWidth
										multiline
										rows={4}
										id={"approval_reason"}
										name={"approval_reason"}
										label={"Receive / Reject Reason"}
										size="small"
										variant="outlined"
										onChange={handleReasonChange}
										InputProps={{
											readOnly:  submissionDetailResult !== null ? !submissionDetailResult.options.approvable : true,
										}}
									/>
								: ""
							: ""
						}
					</div>

					{
						submissionDetailResult !== null ?
							<div>
								<div className={classes.itemRoot}>
									<Grid container spacing={1}>
										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Submission At: <div className={classes.itemText}>{submissionDetailResult.createdate}</div> By <div className={classes.itemText}>{submissionDetailResult.createuser}</div>
											</Typography>
										</Grid>

										<Grid item xs={12}>
											<Typography variant="subtitle1" gutterBottom>
												Last Updated At: <div className={classes.itemText}>{submissionDetailResult.modifydate}</div> By <div className={classes.itemText}>{submissionDetailResult.modifyuser}</div>
											</Typography>
										</Grid>
									</Grid>
								</div>
								<Divider className={classes.divider} />
							</div>
						: ""
					}
					</div>
				</Grid>

				<Grid item xs={12} sm={12} md={7}>
					<div>
						<div className={classes.webviewer} id="webviewer"></div>
					</div>
				</Grid>
			</Grid>

			<div className={classes.buttonMenu}>
			{
				submissionDetailResult !== null ?
					administrableRight ?
						submissionDetailResult.options.approvable ? 
							<Fragment>
								{
									submissionDetailResult.options.next_possible_stages.map(res => {
										return(
											<Button key={res.stage_seq} variant="contained" color="primary" onClick={() => approvalConfirmAction(res.stage_seq, res.stage_name)}>{res.stage_name}</Button>
										)
									})
								}
							</Fragment>
						: <Fragment></Fragment>
					:
					modifyRight ?
						submissionDetailResult.options.updatable ? 
							<Fragment>
								<Button variant="contained" color="primary" onClick={() => saveModifyConfirmAction(submissionDetailResult.subm_seq)}>Save</Button>
							</Fragment>
						: <Fragment></Fragment>
					: ""
				: ""
			}
			</div>
		</Fragment>
	)
}


export default DocSubDetailForm